import React, { useState, useEffect } from "react";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import { useDispatch } from "react-redux";
import { Onballroommatrixchange } from "./ReportSlice";

export const ReportMatrix = ({
  calendarValue,
  matrixValue,
  selectedYear,
  filter,
  data,
  onChange
}) => {
  const [ReportMatrixValue, setReportMatrixValue] = useState();
  const dispatch = useDispatch();
  const handleChange = (e) => {

    setReportMatrixValue(e);
    onChange(e);
    dispatch(Onballroommatrixchange);
  };

  return (
    <>
      <KendoMultiSelect
        name="ReportMatrix"
        data={data != undefined ? data : []}
        dataTextField={"Id"}
        dataValueField={"Value"}
        onChange={handleChange}
      />
    </>
  );
};
